/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdSetOverview } from './AdSetOverview';
import {
    AdSetOverviewFromJSON,
    AdSetOverviewFromJSONTyped,
    AdSetOverviewToJSON,
    AdSetOverviewToJSONTyped,
} from './AdSetOverview';
import type { PartialProfitabilityData } from './PartialProfitabilityData';
import {
    PartialProfitabilityDataFromJSON,
    PartialProfitabilityDataFromJSONTyped,
    PartialProfitabilityDataToJSON,
    PartialProfitabilityDataToJSONTyped,
} from './PartialProfitabilityData';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface SingleCampaignOverview
 */
export interface SingleCampaignOverview {
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    cpa?: MoneyOutput;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof SingleCampaignOverview
     */
    cpm?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof SingleCampaignOverview
     */
    cpc?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    pnoNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    pnoGross?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    roasNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    roasGross?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    poasNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    poasGross?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    poasBeforeMarketingNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    poasBeforeMarketingGross?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    ctr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    conversionRateNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    conversionRateGross?: number | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof SingleCampaignOverview
     */
    profitNet?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof SingleCampaignOverview
     */
    profitGross?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    profitPercentNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    profitPercentGross?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SingleCampaignOverview
     */
    purchaseCostCompleteNet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleCampaignOverview
     */
    purchaseCostCompleteGross?: boolean;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof SingleCampaignOverview
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {SingleCampaignOverviewFinanceScopeEnum}
     * @memberof SingleCampaignOverview
     */
    financeScope?: SingleCampaignOverviewFinanceScopeEnum;
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof SingleCampaignOverview
     */
    partialProfitability?: PartialProfitabilityData | null;
    /**
     * 
     * @type {{ [key: string]: PartialProfitabilityData; }}
     * @memberof SingleCampaignOverview
     */
    partialProfitabilityGranular?: { [key: string]: PartialProfitabilityData; };
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof SingleCampaignOverview
     */
    partialProfitabilityMarketing?: PartialProfitabilityData | null;
    /**
     * 
     * @type {{ [key: string]: PartialProfitabilityData; }}
     * @memberof SingleCampaignOverview
     */
    partialProfitabilityMarketingGranular?: { [key: string]: PartialProfitabilityData; };
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    unverifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    verifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    ordersNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    ordersGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    turnoverGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    spendGoodsNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    spendGoodsGross?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    purchaseCostUnknownNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    purchaseCostUnknownGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    purchaseCostEstimatedNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    purchaseCostEstimatedGross?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SingleCampaignOverview
     */
    purchaseCostQualityAvailable?: boolean;
    /**
     * At least one exact selected source/day has verified media evidence, including observed zero; not completeness.
     * @type {boolean}
     * @memberof SingleCampaignOverview
     */
    hasObservedMediaSpendContribution?: boolean;
    /**
     * 
     * @type {{ [key: string]: MediaSourceQuality; }}
     * @memberof SingleCampaignOverview
     */
    mediaSourceQualityGranular?: { [key: string]: MediaSourceQuality; };
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    impressions?: number;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    integrationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    statusName?: string;
    /**
     * 
     * @type {SingleCampaignOverviewPerformanceSegmentGrossEnum}
     * @memberof SingleCampaignOverview
     */
    performanceSegmentGross?: SingleCampaignOverviewPerformanceSegmentGrossEnum;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    status?: string;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof SingleCampaignOverview
     */
    snapshot?: PrecalculationSnapshotReadMetadata | null;
    /**
     * 
     * @type {Array<AdSetOverview>}
     * @memberof SingleCampaignOverview
     */
    adSets?: Array<AdSetOverview>;
}


/**
 * @export
 */
export const SingleCampaignOverviewFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type SingleCampaignOverviewFinanceScopeEnum = typeof SingleCampaignOverviewFinanceScopeEnum[keyof typeof SingleCampaignOverviewFinanceScopeEnum];

/**
 * @export
 */
export const SingleCampaignOverviewPerformanceSegmentGrossEnum = {
    AboveBreakEven: 'aboveBreakEven',
    Loss: 'loss',
    LowData: 'lowData'
} as const;
export type SingleCampaignOverviewPerformanceSegmentGrossEnum = typeof SingleCampaignOverviewPerformanceSegmentGrossEnum[keyof typeof SingleCampaignOverviewPerformanceSegmentGrossEnum];


/**
 * Check if a given object implements the SingleCampaignOverview interface.
 */
export function instanceOfSingleCampaignOverview(value: object): value is SingleCampaignOverview {
    return true;
}

export function SingleCampaignOverviewFromJSON(json: any): SingleCampaignOverview {
    return SingleCampaignOverviewFromJSONTyped(json, false);
}

export function SingleCampaignOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleCampaignOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'cpa': json['cpa'] == null ? undefined : MoneyOutputFromJSON(json['cpa']),
        'cpm': json['cpm'] === undefined ? undefined : json['cpm'] === null ? null : NullableMoneyOutputFromJSON(json['cpm']),
        'cpc': json['cpc'] === undefined ? undefined : json['cpc'] === null ? null : NullableMoneyOutputFromJSON(json['cpc']),
        'pnoNet': json['pnoNet'] === undefined ? undefined : json['pnoNet'] === null ? null : json['pnoNet'],
        'pnoGross': json['pnoGross'] === undefined ? undefined : json['pnoGross'] === null ? null : json['pnoGross'],
        'roasNet': json['roasNet'] === undefined ? undefined : json['roasNet'] === null ? null : json['roasNet'],
        'roasGross': json['roasGross'] === undefined ? undefined : json['roasGross'] === null ? null : json['roasGross'],
        'poasNet': json['poasNet'] === undefined ? undefined : json['poasNet'] === null ? null : json['poasNet'],
        'poasGross': json['poasGross'] === undefined ? undefined : json['poasGross'] === null ? null : json['poasGross'],
        'poasBeforeMarketingNet': json['poasBeforeMarketingNet'] === undefined ? undefined : json['poasBeforeMarketingNet'] === null ? null : json['poasBeforeMarketingNet'],
        'poasBeforeMarketingGross': json['poasBeforeMarketingGross'] === undefined ? undefined : json['poasBeforeMarketingGross'] === null ? null : json['poasBeforeMarketingGross'],
        'ctr': json['ctr'] === undefined ? undefined : json['ctr'] === null ? null : json['ctr'],
        'conversionRateNet': json['conversionRateNet'] === undefined ? undefined : json['conversionRateNet'] === null ? null : json['conversionRateNet'],
        'conversionRateGross': json['conversionRateGross'] === undefined ? undefined : json['conversionRateGross'] === null ? null : json['conversionRateGross'],
        'profitNet': json['profitNet'] === undefined ? undefined : json['profitNet'] === null ? null : NullableMoneyOutputFromJSON(json['profitNet']),
        'profitGross': json['profitGross'] === undefined ? undefined : json['profitGross'] === null ? null : NullableMoneyOutputFromJSON(json['profitGross']),
        'profitPercentNet': json['profitPercentNet'] === undefined ? undefined : json['profitPercentNet'] === null ? null : json['profitPercentNet'],
        'profitPercentGross': json['profitPercentGross'] === undefined ? undefined : json['profitPercentGross'] === null ? null : json['profitPercentGross'],
        'purchaseCostCompleteNet': json['purchaseCostCompleteNet'] == null ? undefined : json['purchaseCostCompleteNet'],
        'purchaseCostCompleteGross': json['purchaseCostCompleteGross'] == null ? undefined : json['purchaseCostCompleteGross'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
        'partialProfitability': json['partialProfitability'] === undefined ? undefined : json['partialProfitability'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitability']),
        'partialProfitabilityGranular': json['partialProfitabilityGranular'] == null ? undefined : (mapValues(json['partialProfitabilityGranular'], PartialProfitabilityDataFromJSON)),
        'partialProfitabilityMarketing': json['partialProfitabilityMarketing'] === undefined ? undefined : json['partialProfitabilityMarketing'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitabilityMarketing']),
        'partialProfitabilityMarketingGranular': json['partialProfitabilityMarketingGranular'] == null ? undefined : (mapValues(json['partialProfitabilityMarketingGranular'], PartialProfitabilityDataFromJSON)),
        'unverifiedLeads': json['unverifiedLeads'] == null ? undefined : json['unverifiedLeads'],
        'verifiedLeads': json['verifiedLeads'] == null ? undefined : json['verifiedLeads'],
        'ordersNet': json['ordersNet'] == null ? undefined : json['ordersNet'],
        'ordersGross': json['ordersGross'] == null ? undefined : json['ordersGross'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsGross']),
        'purchaseCostUnknownNet': json['purchaseCostUnknownNet'] == null ? undefined : json['purchaseCostUnknownNet'],
        'purchaseCostUnknownGross': json['purchaseCostUnknownGross'] == null ? undefined : json['purchaseCostUnknownGross'],
        'purchaseCostEstimatedNet': json['purchaseCostEstimatedNet'] == null ? undefined : json['purchaseCostEstimatedNet'],
        'purchaseCostEstimatedGross': json['purchaseCostEstimatedGross'] == null ? undefined : json['purchaseCostEstimatedGross'],
        'purchaseCostQualityAvailable': json['purchaseCostQualityAvailable'] == null ? undefined : json['purchaseCostQualityAvailable'],
        'hasObservedMediaSpendContribution': json['hasObservedMediaSpendContribution'] == null ? undefined : json['hasObservedMediaSpendContribution'],
        'mediaSourceQualityGranular': json['mediaSourceQualityGranular'] == null ? undefined : (mapValues(json['mediaSourceQualityGranular'], MediaSourceQualityFromJSON)),
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'performanceSegmentGross': json['performanceSegmentGross'] == null ? undefined : json['performanceSegmentGross'],
        'status': json['status'] == null ? undefined : json['status'],
        'snapshot': json['snapshot'] === undefined ? undefined : json['snapshot'] === null ? null : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
        'adSets': json['adSets'] == null ? undefined : ((json['adSets'] as Array<any>).map(AdSetOverviewFromJSON)),
    };
}

export function SingleCampaignOverviewToJSON(json: any): SingleCampaignOverview {
    return SingleCampaignOverviewToJSONTyped(json, false);
}

export function SingleCampaignOverviewToJSONTyped(value?: SingleCampaignOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cpa': MoneyOutputToJSON(value['cpa']),
        'cpm': NullableMoneyOutputToJSON(value['cpm']),
        'cpc': NullableMoneyOutputToJSON(value['cpc']),
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'roasNet': value['roasNet'],
        'roasGross': value['roasGross'],
        'poasNet': value['poasNet'],
        'poasGross': value['poasGross'],
        'poasBeforeMarketingNet': value['poasBeforeMarketingNet'],
        'poasBeforeMarketingGross': value['poasBeforeMarketingGross'],
        'ctr': value['ctr'],
        'conversionRateNet': value['conversionRateNet'],
        'conversionRateGross': value['conversionRateGross'],
        'profitNet': NullableMoneyOutputToJSON(value['profitNet']),
        'profitGross': NullableMoneyOutputToJSON(value['profitGross']),
        'profitPercentNet': value['profitPercentNet'],
        'profitPercentGross': value['profitPercentGross'],
        'purchaseCostCompleteNet': value['purchaseCostCompleteNet'],
        'purchaseCostCompleteGross': value['purchaseCostCompleteGross'],
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
        'partialProfitability': PartialProfitabilityDataToJSON(value['partialProfitability']),
        'partialProfitabilityGranular': value['partialProfitabilityGranular'] == null ? undefined : (mapValues(value['partialProfitabilityGranular'], PartialProfitabilityDataToJSON)),
        'partialProfitabilityMarketing': PartialProfitabilityDataToJSON(value['partialProfitabilityMarketing']),
        'partialProfitabilityMarketingGranular': value['partialProfitabilityMarketingGranular'] == null ? undefined : (mapValues(value['partialProfitabilityMarketingGranular'], PartialProfitabilityDataToJSON)),
        'unverifiedLeads': value['unverifiedLeads'],
        'verifiedLeads': value['verifiedLeads'],
        'ordersNet': value['ordersNet'],
        'ordersGross': value['ordersGross'],
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyOutputToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyOutputToJSON(value['spendGoodsGross']),
        'purchaseCostUnknownNet': value['purchaseCostUnknownNet'],
        'purchaseCostUnknownGross': value['purchaseCostUnknownGross'],
        'purchaseCostEstimatedNet': value['purchaseCostEstimatedNet'],
        'purchaseCostEstimatedGross': value['purchaseCostEstimatedGross'],
        'purchaseCostQualityAvailable': value['purchaseCostQualityAvailable'],
        'hasObservedMediaSpendContribution': value['hasObservedMediaSpendContribution'],
        'mediaSourceQualityGranular': value['mediaSourceQualityGranular'] == null ? undefined : (mapValues(value['mediaSourceQualityGranular'], MediaSourceQualityToJSON)),
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'remoteId': value['remoteId'],
        'name': value['name'],
        'integrationName': value['integrationName'],
        'statusName': value['statusName'],
        'performanceSegmentGross': value['performanceSegmentGross'],
        'status': value['status'],
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
        'adSets': value['adSets'] == null ? undefined : ((value['adSets'] as Array<any>).map(AdSetOverviewToJSON)),
    };
}

